import Wrapper from './Wrapper'
import ENUM_SETUP from '../enum/typeSetup'
import mapperCluster from '@/views/checkInKiosk/mapper'
import apiRepository from './apiRepository'
import moment from 'moment'
const validTicket = ({ id, isAdmin }) => {
  return {
    ticketId: id,
    valid: true,
    isAdmin
  }
}

const checkURL = (url) => {
  try {
    const urlOrigin = new URL(url)
    const ticket = urlOrigin.searchParams.get('ticket')
    const admin = !urlOrigin.searchParams.get('admin')
    return {
      ticket,
      admin
    }
  } catch {
    console.log('error parse')
  }
  return {
    ticket: 1,
    admin: true
  }
}
export default {
  checkValidationTicket (context) {
    return new Promise((resolve, reject) => {
      window.checkIn = new Wrapper((w) => {
        const val = w.get()
        if (val.type === ENUM_SETUP.VALID_TICKET) {
          const detail = checkURL(context.state.link)
          resolve(validTicket({ id: detail.ticket, isAdmin: detail.admin }))
        } else if (val.type === ENUM_SETUP.INVALID_TICKET) {
          reject(new Error('error'))
        }
      })
    })
  },
  getListAntrian (context, service, labels = []) {
    return new Promise((resolve, reject) => {
      const ticketNumber = context[0].ticket
      const unitId = context[0].data.unit.id
      const nowDate = moment().format('YYYY-MM-DD')
      // var paramsBooked = new URLSearchParams()
      // paramsBooked.append('unitId.equals', unitId)
      // paramsBooked.append('tanggalKunjungan.equals', nowDate)
      const tanggalKunjungan = nowDate
      // apiRepository.getReservasiOrderSocket(paramsBooked)
      apiRepository.getReservasiOrderSocket({ unitId, tanggalKunjungan })
        .then(_data => {
          const listReservasi = mapperCluster.mapperReservasiOrder(_data.data)
          const objTicket = ['sessionStart', 'checkIn', 'ticketNo', 'status']
          const positionOrder = mapperCluster.mapperPosition(listReservasi, ticketNumber, objTicket, labels)
          if (positionOrder && positionOrder.list.length > 0) {
            service.send({
              type: 'show:antrian',
              data: positionOrder
            })
          } else {
            reject(new Error('NOT DATA'))
          }
          service.send({
            type: 'show:antrian',
            data: []
          })
        })
    })
  },
  getTicketFromAPI (generatedId, service) {
    // no action
    return new Promise((resolve, reject) => {
      // apiRepository.getTicketInfo(generatedId)
      apiRepository.getTicketSocketInfo(generatedId)
        .then(_item => _item.data)
        .then(_data => {
          const listOrder = mapperCluster.onlyWithCluster(_data)
          const nowDay = moment(_data.date)
          if (moment().diff(nowDay, 'days') === 0 && _data.status === 'REMOVE') {
            console.log(new Date(), '[Ticket Sudah di remove]')
            const message = JSON.stringify({
              ticketNo: _data.ticketNo,
              type: 'REMOVE TICKET'
            })
            reject(new Error(message))
          } else if (listOrder.length === 0 && moment().diff(nowDay, 'days') === 0) {
            console.log(new Date(), '[Ticket Tidak Memiliki Order]')
            const message = JSON.stringify({
              ticketNo: _data.ticketNo,
              type: 'NO ORDER'
            })
            reject(new Error(message))
          } else if (listOrder.length > 0 && moment().diff(nowDay, 'days') === 0) {
            service.send({
              type: 'on:checked:ticket',
              data: _data,
              list: listOrder
            })
          } else if (moment().diff(nowDay, 'days') !== 0) {
            console.log(new Date(), '[Ticket Sudah Kadaluarsa]')
            const message = JSON.stringify({
              ticketNo: '',
              type: 'EXPIRED TICKET'
            })
            reject(new Error(message))
          }
        })
        .catch(_err => {
          if (_err.status === 404) {
            console.log(new Date(), '[Ticket Sudah Expired]')
            const message = JSON.stringify({
              ticketNo: '',
              type: 'EXPIRED TICKET'
            })
            reject(new Error(message))
          } else {
            console.log(new Date(), '[Ada Kesalahan Server saat Scan Tiket]')
            const message = JSON.stringify({
              ticketNo: '',
              type: 'ERROR SERVER'
            })
            reject(new Error(message))
          }
        })
    })
  },
  postTicketFromAPI ({ data, ticketNo }) {
    return new Promise((resolve, reject) => {
      const listCheckIn = data.filter(_item => _item.isCheckIn)
      const body = mapperCluster.bodyCheckIn(listCheckIn)
      // apiRepository.checkInQueue(body)
      apiRepository.chekcInKioskSocket(body)
        .then(_resp => _resp.data)
        .then(_data => {
          window.socket.once('RESPONSE:API-CHECKIN', (_evt) => {
            console.log(new Date(), '[Socket check in response received]')
            window.fetchKioskCheckIn.send({
              type: 'on:checkin:ticket'
            })
          })
        })
        .catch(_err => {
          console.log(new Date(), '[Ticket Gagal Check In masalah Server]')
          const message = JSON.stringify({
            ticketNo,
            type: 'ERROR SERVER'
          })
          reject(new Error(message))
        })
      // window.loadingType = 2
      // window.checkIn = new Wrapper((w) => {
      //   const val = w.get()
      //   if (val.type === ENUM_SETUP.ERROR_GET_TICKET) {
      //     reject(new Error('error'))
      //   }
      // })
      // setTimeout(() => {
      //   document.getElementById('ticket-9').click()
      // }, 2500)
    })
  }
}
